export default function () {
  const switchButtons = document.querySelectorAll('.switch')

  switchButtons.forEach(button => {
    button.addEventListener('click', function () {
      const pressed = this.getAttribute('aria-pressed')

      if (pressed === 'false') {
        this.setAttribute('aria-pressed', true)
      } else {
        this.setAttribute('aria-pressed', false)
      }
    }, false)
  }, false)

  const matomoSwitch = document.querySelector('#switch-matomo')

  if (localStorage.getItem('matomoOptOut') === 'true') {
    if (matomoSwitch) {
      matomoSwitch.setAttribute('aria-pressed', 'false')
    }
  } else {
    if (matomoSwitch) {
      matomoSwitch.setAttribute('aria-pressed', 'true')
    }
    initMatomo()
  }

  if (matomoSwitch) {
    matomoSwitch.addEventListener('click', function () {
      const pressed = this.getAttribute('aria-pressed')

      if (pressed === 'false') {
        localStorage.setItem('matomoOptOut', 'true')
      } else {
        localStorage.setItem('matomoOptOut', 'false')
      }
    }, false)
  }
}
